module.exports = __webpack_public_path__ + "static/media/Safe-T.d12f0cc8.JPG";